import { Controller } from "@hotwired/stimulus"

// Syncs a rotating 3D CSS cube with fading text items.
// Usage: data-controller="cube-teaser" data-cube-teaser-duration-value="3500"

export default class extends Controller {
  static targets = ["cube", "text", "header", "dot"]
  static values = {
    duration: { type: Number, default: 7000 }
  }

  connect() {
    this.count = this.textTargets.length
    if (this.count < 2) {
      // Single item: just show it, no animation
      if (this.count === 1) this.textTargets[0].classList.add("cube-text-active")
      return
    }

    this.index    = 0
    this.rotationY = 0

    this.textTargets[0].classList.add("cube-text-active")
    if (this.hasHeaderTarget) this.headerTargets[0].classList.add("cube-text-active")
    if (this.hasDotTarget) this.dotTargets[0].classList.add("cube-dot-active")

    this.interval = setInterval(() => this.advance(), this.durationValue)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  advance() {
    const prev = this.index
    this.index = (this.index + 1) % this.count

    // 1. Text zuerst: alten ausblenden, neuen einblenden + Wave
    this.textTargets[prev].classList.remove("cube-text-active")
    if (this.hasHeaderTarget) this.headerTargets[prev].classList.remove("cube-text-active")
    if (this.hasDotTarget) this.dotTargets[prev].classList.remove("cube-dot-active")

    this.textTargets[this.index].classList.add("cube-text-active")
    if (this.hasHeaderTarget) this.headerTargets[this.index].classList.add("cube-text-active")
    if (this.hasDotTarget) this.dotTargets[this.index].classList.add("cube-dot-active")

    const waveTitle = this.hasHeaderTarget
      ? this.headerTargets[this.index].querySelector("[data-controller~='wave-text']")
      : this.textTargets[this.index].querySelector("[data-controller~='wave-text']")
    if (waveTitle) waveTitle.dispatchEvent(new CustomEvent("wave-text:play"))

    // 2. Würfel dreht sich erst danach
    setTimeout(() => {
      this.rotationY += 90
      this.cubeTarget.style.transform = `rotateY(${this.rotationY}deg)`
    }, 400)
  }
}
